<template>
	<v-tooltip bottom>
		<template v-if="!hide_button" v-slot:activator="{ on }">
			<v-btn
				:disabled="selected_receipt.is_valid === false || disabled"
				class="ma-0"
				flat
				icon
				color="blue"
				v-on="on"
				@click.stop="dialog = true"
			>
				<v-icon class="zmdi zmdi-edit"></v-icon>
			</v-btn>
		</template>
		<span>Chỉnh sửa phiếu</span>
		<v-dialog v-if="dialog" v-model="dialog" max-width="80%">
			<app-card>
				<app-section-loader
					:status="loading.submit"
				></app-section-loader>
				<h4>{{ title }}</h4>
				<p class="fs-14 grey--text mb-1">
					Mã chứng từ hiện tại:
					<strong>{{ selected_receipt.receipt_id }}</strong>
				</p>
				<p class="fs-14 grey--text mb-1">
					Tòa nhà hiện tại:
					<strong>{{ selected_receipt.building }}</strong>
				</p>
				<p class="fs-14 grey--text mb-1">
					Số phòng hiện tại:
					<strong>{{ selected_receipt.room_id }}</strong>
				</p>
				<v-form ref="form">
					<v-container fluid>
						<v-layout row wrap justify-start>
							<template v-for="(field, key, index) in edit_field">
								<v-flex
									:[field.flex_attr]="true"
									:key="index"
									v-if="!field.hidden"
								>
									<v-text-field
										v-if="field.type === 'text'"
										:label="field.label"
										:disabled="
											loading.submit || field.disabled
										"
										v-model="form[key]"
										:prepend-icon="field.prepend_icon"
										:rules="rules[field.rule]"
									>
									</v-text-field>
									<v-text-field
										v-if="field.type === 'number'"
										:label="field.label"
										:disabled="
											loading.submit || field.disabled
										"
										v-model.number="form[key]"
										:prepend-icon="field.prepend_icon"
										:rules="rules[field.rule]"
										:min="field.min"
										:max="field.max"
									>
									</v-text-field>
                                    <v-select
										v-if="field.type === 'list'"
                                        :label="field.label"
                                        :disabled="loading.submit || field.disabled"
                                        v-model="form[key]"
                                        :items="field.items"
                                        :prepend-icon="field.prepend_icon"
                                    ></v-select>
									<v-text-field
										v-if="field.type === 'money' && (key !== 'supplementary_amount' || form.has_supplementary_receipt)"
										:label="field.label"
										:disabled="
											loading.submit || field.disabled
										"
										v-model="form[key]"
										:prepend-icon="field.prepend_icon"
										:rules="rules[field.rule]"
										v-currency
									>
									</v-text-field>
									<v-menu
										v-if="field.type === 'date'"
                                        :close-on-content-click="false"
                                        v-model="menu_date[key]"
                                        :nudge-right="40"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                    >
                                        <v-text-field
                                            slot="activator"
                                            v-model="form[key]"
                                            :label="field.label"
                                            :disabled="
												loading.submit || field.disabled
											"
											:prepend-icon="field.prepend_icon"
                                            readonly
											:rules="rules[field.rule]"
                                        ></v-text-field>
                                        <v-date-picker locale="vi-VI" v-model="form[key]" @input="menu_date[key] = false"></v-date-picker>
                                    </v-menu>
									<v-select
										v-if="field.type === 'list_building'"
										:label="field.label || 'Tòa nhà'"
										:disabled="
											loading.submit || field.disabled
										"
										v-model="form[key]"
										:prepend-icon="field.prepend_icon || 'domain'"
										:rules="rules[field.rule]"
										:items="list_building"
									></v-select>
									<v-select
										v-if="field.type === 'list_room'"
										:label="field.label || 'Số phòng'"
										:disabled="
											loading.submit || field.disabled
										"
										v-model="form[key]"
										item-text="room_id"
										item-value="rooms_id"
										:prepend-icon="field.prepend_icon || 'meeting_room'"
										:rules="rules[field.rule]"
										:items="room_ids"
									></v-select>
									<v-select
										v-if="field.type === 'disbursement_type'"
										:items="EXPENSE_ACCOUNT_OPTIONS.filter(option=>option.value!==ACCOUNT_TYPES.MONTHLY_REPAIR_AND_MATERIAL_PURCHASE)"
										:disabled="loading.submit || field.disabled"
										v-model="form.type"
										required
										:prepend-icon="field.prepend_icon || 'list'"
										:label="field.label || 'Loại chi'"
										:rules="rules[field.rule]"
									></v-select>
                                    <v-select
										v-if="field.type === 'agent'"
                                        :label="field.label || 'Người dẫn phòng'"
                                        :disabled="loading.submit || field.disabled"
                                        v-model="form.agent"
                                        :items="[...bvs, { name: 'Chuyển phòng'}]"
                                        item-text="name"
                                        return-object
                                        :prepend-icon="field.prepend_icon || 'person_pin'"
										:rules="selected_receipt.deposit_type == 1 ? rules[field.rule] : []"
                                    ></v-select>
									<v-menu
										v-if="field.type === 'month'"
										:close-on-content-click="false"
										v-model="menu_date[key]"
										:nudge-right="40"
										lazy
										transition="scale-transition"
										offset-y
										full-width
										min-width="290px"
									>
										<v-text-field
											slot="activator"
											v-model="form[key]"
											label="Chọn tháng"
											:disabled="loading.submit || field.disabled"
											prepend-icon="event"
											readonly
											:rules="rules[field.rule]"
										></v-text-field>
										<v-date-picker
											min="2019-10"
											locale="vi-VI"
											type="month"
											v-model="form[key]"
											@input="menu_date[key] = false"
										></v-date-picker>
									</v-menu>
									<v-checkbox
										v-if="field.type === 'checkbox'"
										:label="field.label"
										:disabled="loading.submit || field.disabled"
										v-model="form[key]"
										:rules="rules[field.rule]"
										hide-details
									></v-checkbox>
								</v-flex>
							</template>
							<slot :form="form"></slot>
						</v-layout>
					</v-container>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn :disabled="loading.submit" @click="cancelInput"
							>Trở về</v-btn
						>
						<v-btn
							:loading="loading.submit"
							:disabled="loading.submit"
							dark
							color="green"
							@click="submit"
							>Chỉnh Sửa</v-btn
						>
					</v-card-actions>
				</v-form>
			</app-card>
		</v-dialog>
	</v-tooltip>
</template>
<script>
import api from "Api";
import { list_building, EXPENSE_ACCOUNT_OPTIONS, BUILDING_TO_CASH_ACCOUNT_ID_MAPPING, ACCOUNT_TYPES } from 'Constants/db-config'
import { Wallet } from 'Components/Form'
import { deepCopy, parseCurrency } from 'Helpers';

export default {
	name: "edit-receipt-component",
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		selected_receipt: Object,
		edit_field: Object,
		title: String,
		receipt_type: String,
		trigger: Boolean,
		hide_button: { type: Boolean, default: false}
	},
	components: {
		Wallet
	},
	data() {
		return {
			form: {
				room_id: '',
				building: '',
				has_supplementary_receipt: false,
				supplementary_amount: ''
			},
			loading: {
				submit: false
			},
			dialog: false,
			rules: {
				required: [
					value => !!value || "Vui lòng điền thông tin này."
				],
				requirePhone: [
					v => !!v || "Vui lòng nhập thông tin này",
					v => (v && v.length <= 10) || "SDT phải ngắn hơn 10 ký tự"
				],
			},
			api_route: {
				deposit: "deposits",
				check_in: "check-ins",
				receipt_room: "receipt-rooms",
				receipt_other: "receipt-other",
				check_out: "check-outs",
				collected: "receipt-collected",
			},
			menu_date: {},
			list_building,
			EXPENSE_ACCOUNT_OPTIONS,
			ACCOUNT_TYPES
		};
	},
    computed: {
        rooms(){
            return this.$store.state.app.rooms
        },
        room_ids(){
            return this.rooms.filter( room => room.building === this.form.building)
		},
        bvs(){
            return this.$store.state.app.bvs
        }
    },
	watch: {
		dialog(nv) {
			if (nv) this.updateForm();
		},
		trigger(){
			this.dialog = !this.dialog;
		},
	},
	methods: {
		clearInput: function() {
			this.$refs.form.reset();
		},
		cancelInput: function() {
			this.clearInput();
			this.dialog = false;
		},
		updateForm: function() {
			// for (const key in this.selected_receipt) {
			// 	if (this.selected_receipt.hasOwnProperty(key)) {
			// 		const element = this.selected_receipt[key];
			// 		if (this.edit_field && this.edit_field[key] && this.edit_field[key].type === "date"){
			// 			this.form[key] = element ? element.substr(0, 10) : element;
			// 		} else this.form[key] = element;
			// 	}
			// }
			this.form._id = this.selected_receipt._id;
			for (const key in this.edit_field){
				if (this.edit_field.hasOwnProperty(key)){
					const value = this.selected_receipt[key];
					const edit_type = this.edit_field[key].type;
					switch (edit_type){
						case "date":
							this.form[key] = value ? value.substr(0, 10) : value;
							break;
						case "agent":
							this.form[key] = this.bvs.find(agent => agent.user_id == this.selected_receipt.agent_id) || {};
							break;
						default:
							this.form[key] = deepCopy(value);
					}
				}
			}
		},
		submit: async function() {
            this.loading.submit = true
			const postData = {};
            for (const key in this.edit_field) {
                if (this.edit_field.hasOwnProperty(key)) {
					// if (this.edit_field[key].type === "money"){
					// 	postData[key] = parseCurrency(this.form[key], "vi-VN", 'VND')
					// } else if (this.edit_field[key].type === "date"){
					// 	postData[key] = new Date(this.form[key])
					// } else {
					// 	postData[key] = this.form[key]
					// }
					const edit_type = this.edit_field[key].type;

					switch (edit_type) {
						case "money":
							postData[key] = parseCurrency(this.form[key], "vi-VN", 'VND');
							break;
						case "date":
							postData[key] = new Date(this.form[key]);
							break;
						case "agent":
							postData.agent_id = this.form.agent.user_id
            				postData.agent_name = this.form.agent.name || this.form.agent.username
							break;
						default:
							postData[key] = this.form[key]
					}
                }
            }


            postData.note = this.form.edit_note;

			if ([ACCOUNT_TYPES.RECEIPT_ROOM, ACCOUNT_TYPES.RECEIPT_OTHER].includes(this.receipt_type)) {
				const receipt_id_parts = this.selected_receipt.receipt_id.split(".");
				receipt_id_parts[0] = postData.building;
				postData.receipt_id = receipt_id_parts.join(".");
				postData.wallet_account_id = BUILDING_TO_CASH_ACCOUNT_ID_MAPPING[postData.building];
			} else {
				postData.receipt_id = this.selected_receipt.receipt_id;
			}

			const data = await api.updateReceipt(
                `/${this.api_route[this.receipt_type]}/${this.form._id}`,
				postData
			);
            this.loading.submit = false
            if (data.status === 200){
                swal.fire("Thành công", data.data.message, "success")
				this.$emit("updateCurrentReceipt", this.form._id, data.data.updated_field)
				this.clearInput();
                this.dialog = false
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
		}
	}
};
</script>